<template lang="pug">
    .login
        Layout
            Modal(
                title="Success"
                v-model="isSignupSuccessModalShow"
            )
                p This is your login OTP QRCode
                p Make sure you scan the QRCode before you leave this page
                    img(:src="tokenDecrypt.otpBase64Img")
                div(slot="footer")
                        Button(@click="$router.push({name: 'login'})" type="primary" long) Go to portal
</template>
<script>
import { validateResetOTPToken } from "@/api/user";

export default {
    name: "SignupInvite",
    data() {
        return {
            isSignupSuccessModalShow: false,
            tokenDecrypt: {
                currentTaskNumber: "",
                otpBase64Img: "",
            },
        };
    },
    created() {},
    mounted() {
        let { token } = this.$route.query;
        if (token == undefined) {
            this.$router.push({ name: "login" });
        }
        console.log(token);
        validateResetOTPToken({ token })
            .then((res) => {
                if (!res.data.success) throw new Error(res.data.msg);

                if (!res.data.data.userExist) {
                    // this.$Notice.warning({
                    //     title: this.$i18n.t("global.error"),
                    //     desc: `User is Exist`,
                    // });
                    this.$router.push({ name: "login" });
                }

                this.tokenDecrypt = res.data.data.tokenDecrypt;
                this.isSignupSuccessModalShow = true;
            })
            .catch((err) => {
                console.log(err);
                // this.$Notice.warning({
                //     title: this.$i18n.t("global.error"),
                //     desc: `${err}`,
                // });
                this.$router.push({ name: "login" });
            });
    },
    methods: {},
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/view/general/ResetOTP.vue